import { Component } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { BulletComponent } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-bullet-number-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  styles: ['.cell-container { position: relative; }', 'cam-bullet { position: absolute; bottom: -10px; right: -5px }'],
  template: `
    <div class="align-center">
      @if (this.value) {
        <div class="cell-container ">
          <cam-font-icon name="doc" type="lg"></cam-font-icon>
          <cam-bullet type="notif" size="md">{{ this.value }}</cam-bullet>
        </div>
      }
    </div>
  `,
  imports: [FontIconComponent, BulletComponent],
})
export class GridBulletNumberCellComponent extends AbstractCellComponent<unknown, number> {}
